import { useTranslation } from "react-i18next";

export const PhoneLabel = (props: {total_count: number}) => {
  const {t} = useTranslation(['general']);
  return (<div className="staff-details__role input-wrapper">
    <div className="label input__label">{t("total_points_label")}</div>
    <h2>{props.total_count}</h2>
  </div>);
}